import Client from './Clients/AxiosClient'
const resource = '/userlog'

export default {
  get(params = {}) {
    return Client.get(resource, { params: { status: true, ...params } })
  },
  //   getDeleted() {
  //     return Client.get(`${resource}?status=false`)
  //   },
  //   getUser(id) {
  //     return Client.get(`${resource}/${id}`)
  //   },
  //   create(payload) {
  //     return Client.post(`${resource}`, payload)
  //   },
  //   update(payload, id) {
  //     return Client.put(`${resource}/${id}`, payload)
  //   },
  //   delete(id) {
  //     return Client.delete(`${resource}/${id}`)
  //   },
  //   reactivate(id) {
  //     return Client.put(`${resource}/reactivate/${id}`)
  //   },
}
